import { Box, Typography, TextField, InputAdornment } from '@mui/material';
import SvgIcon from './SvgIcon';
import amountIcon from '../assets/icons/amount-filled.svg';

type AmountInputProps = {
  value: number;
  onChange: (value: number) => void;
  currencySymbol: string;
  width?: string | number;
  label?: string;
  disabled?: boolean;
};

export default function AmountInput({
  value,
  onChange,
  currencySymbol,
  width,
  label,
  disabled,
}: AmountInputProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#FAFAFA',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        maxWidth: width,
        color: disabled ? 'textMuted' : 'text',
      }}
    >
      <TextField
        disabled={disabled}
        fullWidth
        size="small"
        type="number"
        inputProps={{
          min: 0,
          step: '50',
        }}
        value={Math.ceil(value * 100) / 100}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (e.target.value.length > 1 && e.target.value[0] === '0') {
            e.target.value = e.target.value.slice(1);
          }
          onChange(parseFloat(e.target.value || '0'));
        }}
        InputProps={{
          style: {
            height: '40px',
          },
          startAdornment: (
            <InputAdornment position="start">{currencySymbol}</InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <SvgIcon
                src={amountIcon}
                style={{ fill: 'inherit', width: 24, display: 'flex' }}
              />
            </InputAdornment>
          ),
        }}
        required
      />
      {label && (
        <Typography
          variant="inherit"
          sx={{ fontSize: '9px', whiteSpace: 'nowrap' }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
}
